// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__qS7Yx"};